const modals = {
  supplierMSgPar: {},
  isSummitFailed: null,
};

export default modals;
